module.exports = __webpack_public_path__ + "static/media/information_Patient_2.0.1d532ecc.pdf";